import useFetchNoPaging from "#src/hooks/useFetchNoPaging";
import { endpointService } from "#src/services/endpoint";
import { useMemo } from "react";

export const useQueryDevice = (workspaceId: string, query: string) => {
  const fetchDeviceParams = useMemo<
    Parameters<typeof endpointService.listDevicesNoPaging>
  >(
    () => [
      workspaceId,
      {
        q: query ? query : undefined,
        sort: undefined,
        os: undefined,
        host_status: undefined,
        tag: undefined,
        policy_compliance: undefined,
        policy_compliance_id: undefined,
        policy_compliance_status: undefined,
        program_id: undefined,
        asset_type: undefined,
        backup_enabled: undefined,
      },
    ],
    [workspaceId, query]
  );

  const { list: deviceList } = useFetchNoPaging(
    endpointService.listDevicesNoPaging,
    fetchDeviceParams
  );

  return deviceList;
};
